<pt-breadcrumbs class="bg-white" [breadcrumbs]="breadcrumbs$ | async" />
<div class="border-b border-solid border-slate-300"></div>

<div *ngIf="user$ | async as user" class="wrapper">
  <pr-manage-user
    [user]="user"
    [isLoggedInUser]="false"
    [brands]="brands$ | async"
    [roles]="roles$ | async"
    (inviteUser)="invite(user)"
  />
</div>
